import { Fragment } from "react";

import { Link } from "react-router-dom";

const EachBox = ({ name, id, maxDiscount }) => {
  return (
    <Fragment>
      <Link to={`/category/${id}`} className=" each-category-box p-3  ">
        <div className=" each-category-box-res position-relative mb-3 w-100">
          <img
            src={`https://images.daapapp.com/covers/${id}.jpg`}
            alt=""
            className="w-100 img-each-category "
          />
          <div className="cash-gift ">
            <div
              className={
                maxDiscount <= 6
                  ? "box-discount-number bg-lite-success"
                  : maxDiscount > 6 && maxDiscount <= 9
                  ? "box-discount-number bg-dap-orang"
                  : maxDiscount > 9 && maxDiscount <= 12
                  ? "box-discount-number bg-dap-blue"
                  : maxDiscount < 12
                  ? "box-discount-number bg-dark "
                  : "box-discount-number bg-dap-red "
              }
            >
              <div className="inner-discount bg-white p-2 rounded ">
                <p className="m-0 ">
                  {" "}
                  تا %{" "}
                  <span
                    className={
                      maxDiscount <= 6
                        ? "text-lite-success "
                        : maxDiscount > 6 && maxDiscount <= 9
                        ? "text-dap-orang "
                        : maxDiscount > 9 && maxDiscount <= 12
                        ? "text-dap-blue "
                        : maxDiscount < 12
                        ? "text-dark "
                        : "text-dap-red "
                    }
                  >
                    {maxDiscount}
                  </span>
                </p>
              </div>

              <p className="font-site p-2  mb-0 text-white ">پاداش نقدی خرید</p>
            </div>
          </div>

          <div className="name-category-boxes d-flex align-items-center w-100 bg-shiri">
            <p className="name-category-p px-3  mb-0  vazir-l  text-nowrap ">
              {name}
            </p>
          </div>
        </div>
      </Link>
    </Fragment>
  );
};

export default EachBox;
